/**
 * @file Cookie 读写
 * @author svon.me@gmail.com
 **/

import Cookie from "js-cookie";
import * as config from "src/config";
import type {CookieAttributes} from "js-cookie";

const autoCookieAttributes = function (): CookieAttributes {
  return {
    path: "/",
    domain: config.VITE_DOMAIN,
  };
}

export const set = function (name: string, value: string, config: CookieAttributes = {}) {
  const option: CookieAttributes = autoCookieAttributes();
  Cookie.set(name, value, {...option, ...config});
}


export const get = function (name: string): string {
  return Cookie.get(name) || "";
}

export const remove = function (name: string, config: CookieAttributes = {}) {
  const option: CookieAttributes = autoCookieAttributes();
  Cookie.remove(name, {...option, ...config});
}